module.exports = __webpack_public_path__ + "img/landing7.e1b9b7e1.jpg";